import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  encrypt(data: string) {
    return CryptoJS.AES.encrypt(data, environment.SECRET_KEY).toString();
  }

  decrypt(encryptedData: string) {
    return CryptoJS.AES.decrypt(encryptedData, environment.SECRET_KEY).toString(
      CryptoJS.enc.Utf8
    );
  }
}
